import { Baselines } from '../types';
import { median, mad } from './stats';

export class BaselineStore {
  baselines: Baselines = {
    yaw: null,
    pitch: null,
    keyInterval: null,
    voiceRms: null,
    stylusPressure: null,
    stylusSpeed: null,
    shoulderAngle: null,
  };

  voiceThreshold = 0.02;

  finalizeHead(yaws: number[], pitches: number[]): void {
    if (yaws.length < 5) return;
    this.baselines.yaw = { med: median(yaws), mad: mad(yaws) };
    this.baselines.pitch = { med: median(pitches), mad: mad(pitches) };
  }

  finalizeKeyboard(intervals: number[]): void {
    if (intervals.length < 3) return;
    this.baselines.keyInterval = { med: median(intervals), mad: mad(intervals) };
  }

  finalizeVoice(rmsValues: number[]): void {
    if (rmsValues.length < 5) return;
    const bgMed = median(rmsValues);
    const bgMad = mad(rmsValues);
    this.baselines.voiceRms = { med: bgMed, mad: bgMad };
    this.voiceThreshold = bgMed + 3 * 1.4826 * bgMad;
    if (this.voiceThreshold < 0.01) this.voiceThreshold = 0.01;
  }

  finalizeStylus(pressures: number[], speeds: number[]): void {
    if (pressures.length < 3) return;
    this.baselines.stylusPressure = { med: median(pressures), mad: mad(pressures) };
    this.baselines.stylusSpeed = { med: median(speeds), mad: mad(speeds) };
  }

  finalizeBody(angles: number[]): void {
    if (angles.length < 5) return;
    this.baselines.shoulderAngle = { med: median(angles), mad: mad(angles) };
  }

  isReady(): boolean {
    return this.baselines.yaw !== null && this.baselines.pitch !== null;
  }
}
